import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;
export const STATIC_BASE = `${BACKEND_URL}/api`;
export const LOGO_URL = `${BACKEND_URL}/api/settings/logo`;

const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem('mrm_token');
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      const path = window.location.pathname;
      if (path !== '/login') {
        localStorage.removeItem('mrm_token');
        localStorage.removeItem('mrm_user');
        window.location.href = '/login';
      }
    }
    return Promise.reject(err);
  }
);

export default api;
